/**
 * Ordinal rank formatting (1 → "1st", 22 → "22nd"), localized via the existing
 * i18n `game.ordinals.*` keys (en: st/nd/rd/th, fr: er/e). Mirrors the inline
 * logic in GameCard so rank displays stay consistent across the app.
 */

type TranslateFn = (key: string) => string;

export function getOrdinalSuffix(rank: number, t: TranslateFn): string {
  const j = rank % 10;
  const k = rank % 100;
  if (j === 1 && k !== 11) return t('game.ordinals.st');
  if (j === 2 && k !== 12) return t('game.ordinals.nd');
  if (j === 3 && k !== 13) return t('game.ordinals.rd');
  return t('game.ordinals.th');
}

/** e.g. 1 → "1st", 3 → "3rd", 11 → "11th". Localized. */
export function getOrdinal(rank: number, t: TranslateFn): string {
  return `${rank}${getOrdinalSuffix(rank, t)}`;
}
